// extracted by mini-css-extract-plugin
export default {"container":"tU","promoapplied":"uU","tobeapplied":"vU","hr":"wU","teal":"xU","promoappliedcontainer":"yU","error":"zU","input":"AU","errorInput":"BU","promo_x":"CU","promo_info":"EU","promoxcontainer":"FU"};
    if(module.hot) {
      // 1738836197874
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  